import React from 'react';
import { injectIntl } from 'react-intl';
import { Grid, Typography } from '@mui/material';
import _ from 'lodash';
import { THEME_COLOR_PALETTES, getValidThemeColorOption } from '../../../constants/my-details';
import AdviserInfoTagChip from '../AdviserInfoTagChip/AdviserInfoTagChip';
import { getPersonalityTagIntl } from '../../../utils/my-details';
import { formatEditorStateValue, getEditorDefaultMessage } from '../../../utils/editor';
import MyEditor from '../../../components/MyEditor/MyEditor';
import { tryTranslate } from '../../../utils/locale';
import AdviserInfoCardAbstract from '../AdviserInfoCardAbstract/AdviserInfoCardAbstract';

const FullWidthStyle = {
  width: '100%'
};

const AdviserInfoPageProfile = props => {
  const { intl, adviserInfo, isIntoView } = props;

  const { personalityTags, adviserMessage } = adviserInfo || {};
  const themeColor = getValidThemeColorOption(adviserInfo);
  const formattedPersonalityTags = personalityTags || [];
  const formattedAdviserMessage = formatEditorStateValue(
    adviserMessage || getEditorDefaultMessage(intl.locale, 'adviser-message')
  );

  return (
    <AdviserInfoCardAbstract
      className="adviser-info-page-profile"
      title={intl.formatMessage({ id: 'adv-info-about-me-title' })}
      adviserInfo={adviserInfo}
      contentHeight="calc(100% - 110px)"
      isIntoView={isIntoView}
    >
      <Grid container wrap="nowrap" style={{ height: '100%' }} sx={{ flexDirection: 'column' }}>
        <Grid className="content-container" style={{ ...FullWidthStyle, flexGrow: 1 }}>
          <Grid
            container
            wrap="nowrap"
            spacing={3}
            style={{ height: '100%' }}
            sx={{ flexDirection: 'column', alignItems: 'flex-start' }}
          >
            <Grid style={FullWidthStyle}>
              <Grid container spacing={1} sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                <Grid>
                  <Typography
                    className="emoji"
                    sx={{
                      display: 'inline'
                    }}
                  >
                    🤠
                  </Typography>
                  <Typography
                    className="title"
                    sx={{
                      display: 'inline'
                    }}
                  >
                    {intl.formatMessage({ id: 'personality-tags' })}
                  </Typography>
                </Grid>
                <Grid>
                  {formattedPersonalityTags.length > 0 ? (
                    <Grid
                      container
                      spacing={1}
                      sx={{
                        alignItems: 'center'
                      }}
                    >
                      {formattedPersonalityTags.map(tag => (
                        <Grid key={tag}>
                          <AdviserInfoTagChip
                            color={THEME_COLOR_PALETTES[themeColor][1]}
                            label={tryTranslate(intl, getPersonalityTagIntl(tag))}
                            isIntoView={isIntoView}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <Typography color="textSecondary">-</Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid style={{ ...FullWidthStyle, flexGrow: 1, overflow: 'hidden' }}>
              <Grid
                container
                wrap="nowrap"
                spacing={1}
                style={{ height: '100%' }}
                sx={{ flexDirection: 'column', alignItems: 'flex-start' }}
              >
                <Grid style={FullWidthStyle}>
                  <Typography
                    className="emoji"
                    sx={{
                      display: 'inline'
                    }}
                  >
                    💬
                  </Typography>
                  <Typography
                    className="title"
                    sx={{
                      display: 'inline'
                    }}
                  >
                    {intl.formatMessage({ id: 'my-intro' })}
                  </Typography>
                </Grid>
                <Grid style={{ ...FullWidthStyle, height: '100%', overflowY: 'auto' }}>
                  <MyEditor editorState={formattedAdviserMessage} readOnly={true} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AdviserInfoCardAbstract>
  );
};

export default injectIntl(AdviserInfoPageProfile);
